
/** @typedef {'html' | 'lexical'} TranslationFieldValueFormat */

export class TranslationFieldValue
{
    /**
     * @param {*} input
     * @returns {TranslationFieldValue}
     */
    static parse(input)
    {
        /** @type {TranslationFieldValueFormat} */
        let format = 'html';
        const value = input;
        if (typeof value === 'string' && value.startsWith('lexical:'))
        {
            // const json = value.substring(8);
            // if (json && json.length > 0 && json.startsWith('{')) { value = JSON.parse(json); }
            // else { value = json; }
            format = 'lexical';
            // value = json;
        }
        return { format, value };
    }

    /**
     * @param {string} html
     * @returns {string}
     */
    static serializeHtml(html)
    {
        return html;
    }

    /**
     * @param {string} html
     * @returns {string}
     */
    static serializeHtmlAsLexical(html)
    {
        return 'lexical:' + html;
    }

    /**
     * @param {TranslationFieldValueFormat} format
     * @param {*} value
     */
    constructor(format, value)
    {
        this.format = format;
        this.value = value;
    }
}